export default "__VITE_ASSET__xUBA9pUr__"